import axios from 'axios'
import {AuthModel, SmsChallengeResponse, UserModel} from './_models'

const API_URL = process.env.REACT_APP_API_URL

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}/Auth/get-user-by-token`
export const GET_TOKEN_URL = `${API_URL}/Auth/get-token`
export const GET_ACCESSTOKEN_WITH_TOKEN_URL = `${API_URL}/Auth/get-access-token-with-token`
export const GET_TOKEN_FOR_MODULE_URL = `${API_URL}/Auth/get-token-for-module`
export const GET_MODULE_ACCESS_TOKEN_URL = `${API_URL}/Auth/get-module-access-token`
export const EXCHANGE_MODULE_ACCESS_TOKEN_URL = `${API_URL}/Auth/exchange-module-access-token`
export const LOGIN_URL = `${API_URL}/Auth/login`
export const REGISTER_URL = `${API_URL}/Auth/register`
export const REQUEST_PASSWORD_URL = `${API_URL}/Auth/forgot_password`

// Server should return AuthModel or SMS challenge information
export function login(
  userName: string,
  password: string,
  email?: string,
  smsCode?: string,
  deviceId?: string
) {
  const payload: Record<string, string> = {
    userName,
    password,
  }

  if (email !== undefined) {
    payload.userMail = email
  }

  if (smsCode) {
    payload.smsCode = smsCode
  }

  if (deviceId) {
    payload.deviceId = deviceId
  }

  return axios.post<AuthModel[] | SmsChallengeResponse>(GET_TOKEN_URL, payload)
}

// Opt-in module login. The legacy endpoint above intentionally remains unchanged.
export function loginForModule(
  moduleCode: string,
  userName: string,
  password: string,
  email?: string,
  smsCode?: string,
  deviceId?: string
) {
  const payload: Record<string, string> = {
    userName,
    password,
    moduleCode,
  }

  if (email !== undefined) {
    payload.userMail = email
  }
  if (smsCode) {
    payload.smsCode = smsCode
  }
  if (deviceId) {
    payload.deviceId = deviceId
  }

  return axios.post<AuthModel[] | SmsChallengeResponse>(GET_TOKEN_FOR_MODULE_URL, payload)
}

export function getModuleAccessToken(
  moduleCode: string,
  userName: string,
  password: string,
  userMail: string
) {
  return axios.post<AuthModel | string>(GET_MODULE_ACCESS_TOKEN_URL, {
    userName,
    password,
    userMail,
    moduleCode,
  })
}

// Server should return AuthModel
export function autologin(token: string, options?: {smsCode?: string; deviceId?: string}) {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
  }

  if (options?.deviceId) {
    headers['X-Device-Id'] = options.deviceId
  }

  if (options?.smsCode) {
    headers['X-Sms-Code'] = options.smsCode
  }

  return axios.post<AuthModel[] | SmsChallengeResponse>(
    GET_ACCESSTOKEN_WITH_TOKEN_URL,
    {},
    {
      headers,
    }
  )
}

export function moduleAutologin(
  token: string,
  options?: {smsCode?: string; deviceId?: string}
) {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    Accept: 'application/json',
  }

  if (options?.deviceId) {
    headers['X-Device-Id'] = options.deviceId
  }
  if (options?.smsCode) {
    headers['X-Sms-Code'] = options.smsCode
  }

  return axios.post<AuthModel[] | SmsChallengeResponse>(
    EXCHANGE_MODULE_ACCESS_TOKEN_URL,
    {},
    {headers}
  )
}

// Server should return AuthModel
export function refreshToken(refreshToken: string) {
  return axios.post<AuthModel[]>(
    GET_ACCESSTOKEN_WITH_TOKEN_URL,
    {},
    {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
        Accept: 'application/json',
      },
    }
  )
}

export function refreshModuleToken(refreshToken: string) {
  return axios.post<AuthModel[]>(
    EXCHANGE_MODULE_ACCESS_TOKEN_URL,
    {},
    {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
        Accept: 'application/json',
      },
    }
  )
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.put(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, {
    email,
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, {
    api_token: token,
  })
}
